import JSON from 'json3';

export const LocalStorageUtil = {
	load: function (key) {
		if (!window || !window.localStorage) return;
		try {
			return JSON.parse(localStorage.getItem(key));
		} catch (e) {
			console && typeof console.error === 'function' && console.error(e);
		}
	},
	save: function (key, value) {
		if (!window || !window.localStorage) return;
		localStorage.setItem(key, JSON.stringify(value));
	},
	remove: function (key) {
		if (!window || !window.localStorage) return;
		localStorage.removeItem(key);
	},
};